import React from 'react';
import Toggle from '@/components/atoms/Toggle';

interface AudioLoopToggleProps {
  isLooping: boolean;
  onToggle: (enabled: boolean) => void;
  disabled?: boolean;
}

const AudioLoopToggle: React.FC<AudioLoopToggleProps> = ({ isLooping, onToggle, disabled = false }) => {
  return (
    <div className="flex items-center justify-between gap-2 rounded-lg border border-slate-200 p-2">
      <span className="text-sm text-gray-700">Loop Audio</span>
      <Toggle
        on={isLooping}
        disabled={disabled}
        onToggle={onToggle}
        title={isLooping ? 'Disable audio looping' : 'Enable audio looping'}
      />
    </div>
  );
};

export default AudioLoopToggle;
